(() => {
  const VAT = 1.25;
  const STORAGE_KEY = "vat_mode";

  const getMode = () => {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "business" ? "business" : "private";
  };

  const setMode = (mode) => {
    localStorage.setItem(STORAGE_KEY, mode);
    render(mode);
  };

  const parsePrice = (text) => {
    if (!text) return null;

    const cleaned = text
      .replace(/\u00A0/g, " ")
      .toLowerCase()
      .replace(/kr/g, "")
      .replace(/eks\.?\s*mva/g, "")
      .replace(/inkl\.?\s*mva/g, "")
      .trim();

    let s = cleaned.replace(/[^\d,.\s-]/g, "");

    if (s.includes(",")) {
      s = s.replace(/[.\s]/g, "").replace(",", ".");
    } else {
      s = s.replace(/\s/g, "");
      const parts = s.split(".");
      if (parts.length > 2) {
        const last = parts.pop();
        s = parts.join("") + "." + last;
      }
    }

    const num = Number(s);
    return Number.isFinite(num) ? num : null;
  };

  const formatNOK = (num) => {
    const fixed = num.toFixed(2);
    const [intPart, decPart] = fixed.split(".");
    const intWithSpace = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return `${intWithSpace},${decPart} kr`;
  };

  const selectors = [
  ".price",
  ".compare-at-price",

  ".cart-item__price",
  ".cart-item__old-price",

  ".cart-items__unit-price-wrapper span:not(.visually-hidden)",
  ".cart-items__unit-price-wrapper s.compare-at-price",

  ".cart-items__price text-component",
  ".cart-items__price-unit",

  ".cart__total-value",
  ".cart__subtotal-container .money",
  ".cart__total-container .money",

  "[data-cart-item-regular-price]",
  "[data-cart-item-final-price]",
  "[data-cart-item-original-price]",
  "[data-cart-total]",
  "[data-cart-subtotal]"
].join(", ");

  const shouldSkip = (el, txt) => {
    if (!txt) return true;

    // Ikke prøv å endre hele prisblokker med masse tekst
    if (txt.length > 60) return true;

    // Må inneholde minst ett tall
    if (!/\d/.test(txt)) return true;

    // Unngå knapper, badges osv
    if (el.closest("button")) return true;

    return false;
  };

  const updatePrices = (mode) => {
    document.querySelectorAll(selectors).forEach(el => {
      const txt = (el.textContent || "").trim();
      if (shouldSkip(el, txt)) return;

      if (!el.dataset.originalPriceText) {
        el.dataset.originalPriceText = txt;
      }

      const original = el.dataset.originalPriceText;
      const value = parsePrice(original);

      if (value == null) return;

      if (mode === "business") {
        const exVat = value / VAT;
        el.textContent = `${formatNOK(exVat)} eks mva`;
      } else {
        el.textContent = original;
      }
    });
  };

  const syncButtons = (mode) => {
    document.querySelectorAll(".vat-switch__btn[data-mode]").forEach(btn => {
      const active = btn.getAttribute("data-mode") === mode;
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.classList.toggle("is-active", active);
    });
  };

  const render = (mode) => {
    updatePrices(mode);
    syncButtons(mode);
  };

  const bindClicks = () => {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".vat-switch__btn[data-mode]");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      setMode(btn.getAttribute("data-mode"));
    }, true);
  };

  const observe = () => {
    const obs = new MutationObserver(() => {
      clearTimeout(window.__vatTimer);
      window.__vatTimer = setTimeout(() => {
        render(getMode());
      }, 100);
    });

    obs.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    bindClicks();
    render(getMode());
    setTimeout(() => render(getMode()), 300);
    setTimeout(() => render(getMode()), 800);
    observe();
  });
})();